import {MESSAGE_TYPE_ASSISTANT, MESSAGE_TYPE_DRAFT, MESSAGE_TYPE_ERROR, MESSAGE_TYPE_USER} from "@/constants";
import {v4 as uuid} from "uuid";

export function formDraftMessage(regeneration) {
    return {
        text: null,
        type: MESSAGE_TYPE_DRAFT,
        id: `${uuid()}-chat`,
        regeneration_id: regeneration?.id,
        can_regenerate: !!regeneration,
    };
}

export function formErrorMessage(message) {
    return {
        text: message,
        type: MESSAGE_TYPE_ERROR,
        id: `${uuid()}-chat`,
        regeneration_id: null,
        can_regenerate: false,
        job_id: null,
        progress: null,
        waiting_message: null,
    };
}

export function createAssistantMessage(id, text, createdAt, reason = null, stat = {}, files = [], images = [], uml = [], canRegenerate = false, search = null, assistant = null, musicFiles = [], webSearch = false) {
    return {
        id,
        text,
        type: MESSAGE_TYPE_ASSISTANT,
        can_regenerate: canRegenerate,
        created_at: createdAt,
        reason,
        stat,
        files,
        images,
        uml,
        search,
        assistant,
        music_files: musicFiles,
        web_search: webSearch,
    };
}

export function createUserMessage(id, text, createdAt, files = [], images = []) {
    return {
        id,
        text,
        type: MESSAGE_TYPE_USER,
        can_regenerate: false,
        created_at: createdAt,
        files,
        images,
    };
}